"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGetApiIntroducerPortalRepaymentSimulator = exports.GET_API_INTRODUCER_PORTAL_REPAYMENT_SIMULATOR_KEY = exports.fetchPostApiIntroducerPortalIntroducerWhatsNew = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = exports.fetchGetApiIntroducerPortalIntroducerWhatsNew = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = exports.fetchGetApiIntroducerPortalIntroducerNotificationSubscription = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_SUBSCRIPTION_KEY = exports.fetchGetApiIntroducerPortalIntroducerNotification = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_KEY = exports.fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFERS_KEY = exports.fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ACCEPT_KEY = exports.fetchPostApiIntroducerPortalIntroducer = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_KEY = exports.fetchGetApiIntroducerPortalIntroducer = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_DRAW_DOWN_REPAYMENT_SCHEDULE_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = exports.fetchGetApiIntroducerPortalIntroducerContextByIntroducerId = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = exports.fetchGetApiIntroducerPortalIntroducerContext = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOffers = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFERS_KEY = exports.fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = exports.PUT_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = exports.fetchPostApiIntroducerPortalIntroducerAccount = exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_ACCOUNT_KEY = exports.LapiError = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
const lendingAPI_1 = require("./lendingAPI");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
Object.defineProperty(exports, "LapiError", { enumerable: true, get: function () { return lendingAPI_2.LapiError; } });
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_ACCOUNT_KEY = "postApiIntroducerPortalIntroducerAccount";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducerAccount({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/account/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerAccount = fetchPostApiIntroducerPortalIntroducerAccount;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "getApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate";
/**
 * Returns the currently configured withdrawal fee for an offer
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = fetchGetApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate;
exports.PUT_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "putApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate";
/**
 * Update the currently configured withdrawal fee for an offer
 */
function fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "put",
        body,
    });
}
exports.fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate = fetchPutApiIntroducerPortalIntroducerApplicationOfferWithdrawalFeeRate;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFERS_KEY = "getApiIntroducerPortalIntroducerApplicationOffers";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOffers({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offers/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOffers = fetchGetApiIntroducerPortalIntroducerApplicationOffers;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_KEY = "getApiIntroducerPortalIntroducerContext";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerContext({}) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/context/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerContext = fetchGetApiIntroducerPortalIntroducerContext;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = "getApiIntroducerPortalIntroducerContextByIntroducerId";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerContextByIntroducerId({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/context/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerContextByIntroducerId = fetchGetApiIntroducerPortalIntroducerContextByIntroducerId;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = "getApiIntroducerPortalIntroducerApplicationOfferFundingRequirements";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements({ introducerId, applicationId, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/funding_requirements/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements = fetchGetApiIntroducerPortalIntroducerApplicationOfferFundingRequirements;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_DRAW_DOWN_REPAYMENT_SCHEDULE_KEY = "getApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule({ introducerId, applicationId, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/draw_down_repayment_schedule/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule = fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = "getApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/allowed_withdrawal_fee_rates/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates = fetchGetApiIntroducerPortalIntroducerApplicationOfferAllowedWithdrawalFeeRates;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = "getApiIntroducerPortalIntroducerApplicationRejectOfferReasons";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/reject_offer_reasons/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons = fetchGetApiIntroducerPortalIntroducerApplicationRejectOfferReasons;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_KEY = "getApiIntroducerPortalIntroducer";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducer({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducer = fetchGetApiIntroducerPortalIntroducer;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_KEY = "postApiIntroducerPortalIntroducer";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducer({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducer = fetchPostApiIntroducerPortalIntroducer;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_OFFER_ACCEPT_KEY = "postApiIntroducerPortalIntroducerApplicationOfferAccept";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/accept/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept = fetchPostApiIntroducerPortalIntroducerApplicationOfferAccept;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_APPLICATION_REJECT_OFFERS_KEY = "postApiIntroducerPortalIntroducerApplicationRejectOffers";
/**
 * No description
 */
function fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers({ introducerId, applicationId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/application/${applicationId}/reject_offers/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers = fetchPostApiIntroducerPortalIntroducerApplicationRejectOffers;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_KEY = "getApiIntroducerPortalIntroducerNotification";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerNotification({ introducerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/notification/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerNotification = fetchGetApiIntroducerPortalIntroducerNotification;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_NOTIFICATION_SUBSCRIPTION_KEY = "getApiIntroducerPortalIntroducerNotificationSubscription";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerNotificationSubscription({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/notification/subscription/`, {
        method: "get",
    });
}
exports.fetchGetApiIntroducerPortalIntroducerNotificationSubscription = fetchGetApiIntroducerPortalIntroducerNotificationSubscription;
exports.GET_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = "getApiIntroducerPortalIntroducerWhatsNew";
/**
 * No description
 */
function fetchGetApiIntroducerPortalIntroducerWhatsNew({ introducerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/whats_new/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalIntroducerWhatsNew = fetchGetApiIntroducerPortalIntroducerWhatsNew;
exports.POST_API_INTRODUCER_PORTAL_INTRODUCER_WHATS_NEW_KEY = "postApiIntroducerPortalIntroducerWhatsNew";
/**
 * Mark all unread notifications as read
 */
function fetchPostApiIntroducerPortalIntroducerWhatsNew({ introducerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/introducer/${introducerId}/whats_new/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApiIntroducerPortalIntroducerWhatsNew = fetchPostApiIntroducerPortalIntroducerWhatsNew;
exports.GET_API_INTRODUCER_PORTAL_REPAYMENT_SIMULATOR_KEY = "getApiIntroducerPortalRepaymentSimulator";
/**
 * No description
 */
function fetchGetApiIntroducerPortalRepaymentSimulator({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/introducer_portal/repayment_simulator/`, {
        method: "get",
        query,
    });
}
exports.fetchGetApiIntroducerPortalRepaymentSimulator = fetchGetApiIntroducerPortalRepaymentSimulator;
